/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import {
  PAGES__ROLE_ERROR,
  PAGES__ROLE_FINALIZER,
  PAGES__ROLE_TERMINATION_FINALIZER,
  PAGES__SHAPE_ITEM,
} from '../../../../redux/constants';

import { labelCss, navItemCss } from './nav.style';
import { surveyClientSetPageIndex } from '../../../../redux/survey-client/actions.survey-client';
import { hasAnswer } from '../../../../redux/selectors';

export const getIcon = (role, index) => {
  switch (role) {
    case PAGES__ROLE_ERROR:
      return <span className="fa fa-exclamation" />;
    case PAGES__ROLE_FINALIZER:
      return <span className="fa fa-trophy" />;
    case PAGES__ROLE_TERMINATION_FINALIZER:
      return <span className="fa fa-lock" />;
    default:
      return index;
  }
};

const ClientNavItem = ({ index, navIndex, page, showPreviousButton, role }) => {
  const dispatch = useDispatch();

  const hasAnswers = useSelector((state) => hasAnswer(state, page));
  const displayIndex = index + 1;
  const active = navIndex === index;
  const locked = showPreviousButton ? !hasAnswers && !active : index > navIndex;

  return (
    <button
      css={navItemCss({ active, locked, readOnly: !showPreviousButton })}
      onClick={(event) => {
        if (locked) {
          event.preventDefault();
          return;
        }
        const action = surveyClientSetPageIndex(displayIndex);
        dispatch(action);
      }}
      type="button"
    >
      <div className="nav-item__label" css={labelCss(active, locked, role === PAGES__ROLE_ERROR)}>
        {getIcon(role, displayIndex)}
      </div>
    </button>
  );
};

ClientNavItem.propTypes = {
  index: PropTypes.number.isRequired,
  navIndex: PropTypes.number.isRequired,
  page: PAGES__SHAPE_ITEM.isRequired,
  showPreviousButton: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired,
};

export default ClientNavItem;
